import {DG_axios} from "../../../custom/axios";
import {DG_axiosNormal} from "../../../custom/axios/normal";

const BASE_URL = `/dogoo/common-config-rest/v2.0/common-config-rest`;
const BASE_URL_CYCLES = `/dogoo/common-config-rest/v2.0/timekeeping/cycle-list-date`;
const BASE_URL_IS_CLOS_TIMEKEEPING_CYCLES = `/dogoo/common-config-rest/v2.0/timekeeping/is-close-timekeeping`;
const BASE_URL_IS_CLOS_APPLICATION_CYCLES = `/dogoo/common-config-rest/v2.0/timekeeping/is-close-application`;

export const addTimekeepingCommonConfigApi = async (TimekeepingCommonConfig) => {
    const response = await DG_axiosNormal.post(BASE_URL, TimekeepingCommonConfig);
    return response.data || [];
};

export const loadTimekeepingCommonConfigApi = async (params) => {
    const config = {params: params};
    const response = await DG_axios.get(BASE_URL, config);
    return response.data || [];

};

export const updateAttendance = async(attendanceGPS) => {
    const response = await DG_axios.put(`${BASE_URL}?attendanceGPS=${attendanceGPS}`);

    return response.data || []
};

export const loadTimeKeepingCycle = async (params) => {
    const config = {params: params};
    const response = await DG_axios.get(`${BASE_URL_CYCLES}`, config);
    return response.data || [];

};

export const updateIsClosTimekeepingTimeKeepingCycle = async (timeKeepingCycle) => {
    const response = await DG_axios.put(BASE_URL_IS_CLOS_TIMEKEEPING_CYCLES, timeKeepingCycle);
    return response?.data;
};
export const updateIsClosApplicationTimeKeepingCycle = async (timeKeepingCycle) => {
    const response = await DG_axios.put(BASE_URL_IS_CLOS_APPLICATION_CYCLES, timeKeepingCycle);
    return response?.data;
};

